<template>
  <textarea
    class="md-input"
    v-model="inputValue"
    :disabled="disabled || null"
    :required="required"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :readonly="readonly"
    :scrollParams="scrollParams"
    @change="onChange"
    @focus="onFocus"
    @blur="onBlur"
    ></textarea>
</template>

<script>
  import autosize from 'autosize';
  import common from './common';

  function onResized() {
    this.$emit('resized', this.$el.clientHeight);
  }

  export default {
    name: 'md-textarea',
    mixins: [common],
    props: {
      maxHeight: {
        type: Number
      }
    },
    watch: {
      inputValue(newValue, oldValue) {
        this.onUpdateValue(this.inputValue || '')
      },
      modelValue() {
        // HACK: autosize doesn't work properly on text changes.
        // $nexTick only and requestAnimation frame produces erratic behaviors
        this.$nextTick(() => {
          setTimeout(() => autosize.update(this.$el), 200);
        });
      }
    },
    methods: {
    },
    mounted() {
      this.$nextTick(() => {
        if (!this.$el.getAttribute('rows')) {
          this.$el.setAttribute('rows', '1');
        }

        if (this.maxHeight) {
          this.$el.style.maxHeight = `${this.maxHeight}px`;
        }

        autosize(this.$el);

        this.$el.addEventListener('autosize:resized', onResized.bind(this));

        setTimeout(() => autosize.update(this.$el), 200);
      });
    },
    beforeUnmount() {
      this.$el.removeEventListener('autosize:resized', onResized.bind(this));
      autosize.destroy(this.$el);
    }
  };
</script>
